import React, { useState, useEffect } from "react";
// import clsx from "clsx";
import {
  // useFormChangeHandler,
  useFormChangeHandlerV2,
} from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";
// import Select from "react-select";
// import makeAnimated from "react-select/animated";
// import { IconChevronLeft, IconTrash } from "@tabler/icons-react";
import FormGroup from "./FormGroup";
import { useProduct } from "contexts/v1/masterData/ProductContext";
import { useAgent } from "contexts/v1/masterData/AgentContext";
import { useLabel } from "contexts/v1/masterData/LabelContext";

// const animatedComponents = makeAnimated();

const QuickCreatePage = ({
  initialData,
  onSuccess,
  onError,
  sessions,
  customers,
}) => {
  // console.log("sessions", sessions);
  // const { products = [], refetch } = useProduct(); // Berikan default array kosong
  const { products = { data: [] }, refetch } = useProduct();
  const { agents = { data: [] } } = useAgent();
  const agentList = agents.data || [];
  const productList = products.data || [];
  const { labels } = useLabel();
  const labelList = labels.data || [];
  console.log("labels", labels);
  console.log("initial customers", customers);
  console.log("agentList", agentList);
  console.log("products", productList);
  const API_URL = "/reservation/quick"; // API URL sesuai dengan endpoint booking Anda
  const [formData, setFormData] = useState({
    // reservation_date: "", // required|date auto hari ini
    reservation_date: new Date().toISOString().split("T")[0], // required|date auto hari ini
    trip_id: "", // required|exists:App\Models\Trip,id
    agent_id: "", // required|exists:App\Models\Agent,id
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        ...initialData,
      });
      console.log("useEffect initialData", initialData);
    }
  }, [initialData]);

  // Konversi data sessions ke format yang sesuai untuk opsi select
  const sessionOptions = sessions?.map((session) => ({
    value: session.id,
    label: `${session.name} (${session.start_time} - ${session.end_time})`,
  }));

  const isUpdateMode = !!initialData;

  const { createData: createBooking, loading: creatingBooking } = useCreateData(
    API_URL,
    "bookings"
  );
  const { updateData: updateBooking, loading: updatingBooking } = useUpdateData(
    `${API_URL}/${initialData?.id}`,
    "bookings"
  );

  // const handleChange = useFormChangeHandler(setFormData);
  const handleChange = useFormChangeHandlerV2(setFormData);

  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    isUpdateMode ? updateBooking : createBooking,
    onSuccess,
    onError
  );

  const handleBeforeSubmit = (e) => {
    e.preventDefault();

    // Validasi khusus untuk PU
    if (formData.guest_transport === "PU" && !formData.guest_pu_time) {
      alert("PU Time wajib diisi jika jenis transportasi adalah Pick Up (PU).");
      return;
    }

    // jika guest_transport adalah OT jangan kirim guest_pu_location
    if (formData.guest_transport === "OT") {
      delete formData.guest_pu_location;
    }

    // Payload data
    const payload = {
      ...formData,
    };

    handleSubmit(payload, e);
  };

  // Konversi data agents ke format yang sesuai untuk opsi select
  const agentOption = agentList?.map((agent) => ({
    value: agent.id,
    label: agent.name,
  }));

  return (
    <form
      onSubmit={handleBeforeSubmit}
      className="d-flex flex-column"
      style={{ height: "100%" }}
    >
      <div className="action-sheet-content flex-grow-1">
        {/*Ketersediaan */}
        <div className="card mb-3">
          {/* <button className="btn" onClick={handleBack}>
            <IconChevronLeft size={18} /> Kembali
          </button> */}

          <div className="card-header">
            <h5 className="card-title">Availability</h5>
          </div>
          <div className="card-body">
            <div className="row">
              {/* Tanggal Pemesanan */}
              <FormGroup
                id="reservation_date"
                label="Booking Date"
                type="date"
                value={formData.reservation_date}
                onChange={handleChange}
                error={formError?.reservation_date}
                disabled={isSubmitting}
              />
              {/* Session Select */}
              <FormGroup
                id="trip_id"
                label="Select Trip"
                as="select"
                value={
                  sessionOptions?.find(
                    (option) => option.value === formData.trip_id
                  ) || null
                } // Pastikan ini adalah objek
                onChange={(selectedOption) =>
                  handleChange(selectedOption, "trip_id")
                } // Tangani perubahan nilai
                options={sessionOptions} // Daftar opsi
                placeholder="Select a Trip"
                error={formData.trip_id === "" ? "Please select a trip" : null}
              />
              <FormGroup
                id="agent_id"
                label="Select Agent"
                as="select"
                value={
                  agentOption?.find(
                    (option) => option.value === formData.agent_id
                  ) || null
                } // Pastikan ini adalah objek
                onChange={(selectedOption) =>
                  handleChange(selectedOption, "agent_id")
                } // Tangani perubahan nilai
                options={agentOption} // Daftar opsi
                placeholder="Select a Agent"
                // error={formData.agent_id === "" ? "Please select Agent" : null}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Submit Button */}
      <div className="form-group mt-auto d-grid">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={isSubmitting}
        >
          {isUpdateMode ? "Update Booking" : "Create Booking"}
        </button>
      </div>
    </form>
  );
};

export default QuickCreatePage;
